import * as Material from "@mui/material";

export default function Select({options, value, onChange}) {
  return (
    <Material.FormControl className="community-select" fullWidth>
      <Material.Select
        size="small"
        variant="filled"
        value={value}
        onChange={(v) => onChange(v.target.value)}
      >
        {options?.map((c, i) => (
          <Material.MenuItem value={c.id} key={"CommFilter-" + i}>
            {c.label}
          </Material.MenuItem>
        ))}
      </Material.Select>
    </Material.FormControl>
  );
}
